<template>
  <div>
    <GlobalEvents
      target="window"
      @mousedown.once="_safariFix"
    ></GlobalEvents>

    <!-- Sounds -->
    <audio ref="blop" autobuffer="true">
      <source src="/sounds/blop.mp3" type="audio/mpeg">
      <source src="/sounds/blop.ogg" type="audio/ogg">
    </audio>
    <audio ref="silent" autobuffer="true">
      <source src="/sounds/silent.mp3" type="audio/mpeg">
      <source src="/sounds/silent.ogg" type="audio/ogg">
    </audio>
  </div>
</template>

<script>
  import GlobalEvents from 'vue-global-events';
  import eventBus from '../assets/js/event-bus';


  export default {
    name: 'Sound',

    components: {
      GlobalEvents
    },

    mounted() {
      eventBus.$on('playSound', this.play);
    },

    destroyed() {
      eventBus.$off('playSound', this.play);
    },

    methods: {
      async play(sound) {
        sound = sound || Object.keys(this.$refs)[0];

        const audio = this.$refs[sound];
        if (audio) {
          try {
            await audio.play();
            if (typeof window.navigator.vibrate === 'function') {
              setTimeout(() => window.navigator.vibrate(200), 300);
            }
          } catch (error) {
            /* NOOP */
          }

        } else {
          console.warn(`Sound "${sound}" not available.`); // eslint-disable-line no-console
        }
      },

      _safariFix() {
        // Safari hack to fix audio.
        if (/.*Version.*Safari.*/.test(navigator.userAgent)) {
          this.play('silent');
        }
      }
    }
  };
</script>
